import { Typography } from '@telus-uds/components-web';

export default function NotAllowed() {
  return (
    <Typography block variant={{ size: 'display2' }} heading="h2">
      Sorry, Form not available
    </Typography>
  );
}
